module.exports = __webpack_public_path__ + "c7503b223833991d8c7972451121d7c2.svg";